import { render, staticRenderFns } from "./minichallenge-autocomplete.vue?vue&type=template&id=6ef09fb4&scoped=true"
import script from "./minichallenge-autocomplete.vue?vue&type=script&lang=js"
export * from "./minichallenge-autocomplete.vue?vue&type=script&lang=js"
import style0 from "./minichallenge-autocomplete.vue?vue&type=style&index=0&id=6ef09fb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef09fb4",
  null
  
)

export default component.exports